/** @jsx jsx */
import { useTranslation } from 'react-i18next';
import { jsx } from '@emotion/core';

import questionsIcon from 'assets/icons/declaration-form-step3.svg';
import { OverviewOfDeclarationsAccordion } from './OverviewOfDeclarationsAccordion';
import { BasicOverview } from './BasicOverview';
import proofIcon from 'assets/icons/declaration-form-step2.svg';
import { StyledAsterixDetails } from './styles';
import { TProductDetails } from 'interfaces/challenge.types';

export const FinalStepOverview = ({
  products,
  questionsAnswered,
  filesUploaded,
  totalDeclarationQuantityPreview,
  totalDeclarationFinancialValuePreview,
  totalDeclarationRewardPreview,
  totalDeclarationResultPreview,
  displayFinancialValues,
  isGoalMecanicByProduct,
  unitToDisplay,
  isProofStepRequired,
  isQuestionsStepRequired,
}: {
  products?: TProductDetails[];
  questionsAnswered: number;
  filesUploaded?: number;
  totalDeclarationQuantityPreview: number;
  totalDeclarationFinancialValuePreview: number;
  totalDeclarationRewardPreview: number;
  totalDeclarationResultPreview: number;
  displayFinancialValues: boolean;
  isGoalMecanicByProduct: boolean;
  unitToDisplay: string | null;
  isProofStepRequired: boolean;
  isQuestionsStepRequired: boolean;
}): JSX.Element => {
  const { t } = useTranslation();

  return (
    <div>
      {/* Overview of the products sales declarations provided in the previous products step */}
      {products && (
        <OverviewOfDeclarationsAccordion
          products={products}
          totalDeclarationQuantityPreview={totalDeclarationQuantityPreview}
          totalDeclarationFinancialValuePreview={
            totalDeclarationFinancialValuePreview
          }
          totalDeclarationRewardPreview={totalDeclarationRewardPreview}
          totalDeclarationResultPreview={totalDeclarationResultPreview}
          displayFinancialValues={displayFinancialValues}
          isGoalMecanicByProduct={isGoalMecanicByProduct}
          unitToDisplay={unitToDisplay}
        />
      )}
      {/* Overview of the proof provided in the previous proof step */}
      {isProofStepRequired && (
        <BasicOverview
          title={t('challenges.declaration.summary.proof')}
          statementText={t('challenges.declaration.summary.proofStatement', {
            filesUploaded,
          })}
          icon={<img src={proofIcon} alt="proof icon" />}
        />
      )}
      {/* Overview of the answers provided in the previous questions step */}
      {isQuestionsStepRequired && (
        <BasicOverview
          title={t('challenges.declaration.summary.questions')}
          statementText={t(
            'challenges.declaration.summary.questionsStatement',
            {
              questionsAnswered,
            },
          )}
          icon={<img src={questionsIcon} alt="questions icon" />}
        />
      )}
      {isGoalMecanicByProduct && unitToDisplay && (
        <StyledAsterixDetails>
          {t('challenges.declaration.summary.asteriskDetails')}
        </StyledAsterixDetails>
      )}
    </div>
  );
};

FinalStepOverview.defaultProps = {
  filesUploaded: 1,
};
